import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SizeChartComponent } from '../size-chart/size-chart.component';

@Component({
  selector: 'calsoft-size-chart-popup',
  templateUrl: './size-chart-popup.component.html',
  styleUrls: ['./size-chart-popup.component.scss']
})
export class SizeChartPopupComponent {

  @Input()  sizeChartId: any;

  @Input()  name: any;


  @Input()  data:any;

  width: any='400px';

  constructor(
    
    private dialog: MatDialog,

    
    
  ) { }

  ngOnInit() {
         

    this.width=this.data['sizeChartWidth']

  }

  

  sizeChart() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(SizeChartComponent, {
        width: this.width,
        data: { sizeChartId: this.sizeChartId,
          name:this.name
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        


      });

    }
    else {
      let dialogRef = this.dialog.open(SizeChartComponent, {
        minWidth: '100vw', height: '100vh',
        data: { sizeChartId: this.sizeChartId, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
   


      });
    }

  }
}
